export default "__VITE_ASSET__CoiD3yQT__"